/**
 * رمزِ تازه — کجا قبول است، کجا نه.
 *
 * چند جا رمزِ تازه گرفته می‌شود (ثبت‌نامِ اپ و وب، بازیابیِ رمز، و از
 * WHOSUP-367 «تغییر رمز» در پروفایل — `changePassword.ts`) و قاعده باید مو
 * به مو یکی باشد؛ این‌جا تابعِ خالص است تا با `npm test` سنجیده شود و همه‌ی
 * فرم‌ها از یک جا بخوانند.
 *
 * قاعده‌ی «ساده نباشد»: فقط طول کافی نیست — «password» و «123456» هر دو
 * شش‌تایی‌اند و هر دو اولین حدس‌های هر فهرستِ رمزِ لوشده. پس حرفِ
 * انگلیسی باید با غیرِ حرف (عدد یا نشانه) ترکیب شود. عمداً همین و نه
 * بیشتر: اجبارِ حرفِ بزرگ و نشانه و عدد با هم، آدم را به `Password1!`
 * می‌رساند نه به رمزِ بهتر.
 *
 * حرف یعنی a-z: همان تعریفی که گزینه‌ی letters_digits خودِ Supabase دارد،
 * پس اگر روزی آن سمت هم روشن شود، این دو با هم نمی‌جنگند.
 */

/** همان کفی که Supabase هم کمتر از آن را رد می‌کند. */
export const PASSWORD_MIN = 6;

export type PasswordProblem =
  /** کوتاه‌تر از `PASSWORD_MIN`. */
  | 'short'
  /** همه‌حرف یا بی‌حرف — ترکیبِ حرف و غیرِ حرف می‌خواهد. */
  | 'simple';

/** مشکلِ این رمز، یا `null` اگر قبول است. ترتیبِ پیام‌ها: اول کوتاهی. */
export function passwordProblem(pw: string): PasswordProblem | null {
  if (pw.length < PASSWORD_MIN) return 'short';
  if (!/[a-z]/i.test(pw) || !/[^a-z]/i.test(pw)) return 'simple';
  return null;
}
